export interface IContactItemProps {
  text: string;
  icon: EIcons;
  isPhone?: boolean;
  isEmail?: boolean;
  link?: string;
  className?: string;
}

export enum EIcons {
  ADDRESS = 'address',
  TIME = 'time',
  PHONE = 'phone',
  EMAIL = 'email',
  TELEGRAM = 'telegram',
  VK = 'vk',
}
